import _defineProperty from "/codebuild/output/src750133160/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/amazing-revolution/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as AWS from "aws-sdk";
configureLogger(window.OPSEEKER_CONFIG);
var DeliveryStreamName = window.OPSEEKER_CONFIG.LOGGER_DeliveryStreamName;
export var sendLogToFirehose = function sendLogToFirehose(params) {
  AWS.config.credentials.get(function (err) {
    if (err) {
      console.error(err);
      return;
    }

    putRecordToFirehose(new AWS.Firehose(), buildRecord(params));
  });
};

function buildRecord(params) {
  return {
    Data: JSON.stringify(_objectSpread(_objectSpread({}, params), {}, {
      referrer: window.location.origin,
      request: !window.location.search ? "index" : window.location.search,
      deviceType: getDeviceType(),
      time: new Date()
    })) + "\n"
  };
}

function putRecordToFirehose(firehose, record) {
  firehose.putRecord({
    Record: record,
    DeliveryStreamName: DeliveryStreamName
  }, function (err, data) {
    if (err) {
      console.error(err);
    }
  });
}

function configureLogger(configParams) {
  AWS.config.update({
    region: configParams.LOGGER_region,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: configParams.LOGGER_identity_pool_id
    })
  });
}

export function getDeviceType() {
  return window.outerWidth > 992 ? "desktop" : window.outerWidth < 600 ? "mobile" : "tablet";
}
var isLocalHost = window.location.origin.includes('localhost:');
export var sendLog = isLocalHost ? function () {} : sendLogToFirehose;